
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAvatarLayerAdd } from '@/modules/avatar/layer/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.LAYER.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, create } = useAvatarLayerAdd();

        return { v$, model, create };
    }
});
